module.exports = __webpack_public_path__ + "img/code2.92de4bc3.png";